import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    tickers: []
  },
  mutations: {
    setTickers(state, payload) {
      state.tickers = payload;
    }
  },
  actions: {
    getTickers({ commit }) {
      return api.getTickers().then(({ data }) => {
        commit('setTickers', data);
      });
    }
  }
};

appStore.registerModule('myTokenTicker', store);
